import { Box, CircularProgress, Typography } from "@mui/material";

export default function FallbackUI() {
    return (
        <Box
            className="fallback h-full"
            sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                gap: 2,
            }}
        >
            <CircularProgress
                size={40}
                thickness={4}
                sx={{
                    color: "primary.main",
                }}
            />
            <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                Loading...
            </Typography>
        </Box>
    );
}
